import { render, staticRenderFns } from "./CardDatesDetailBarChart.vue?vue&type=template&id=87580cb0"
import script from "./CardDatesDetailBarChart.vue?vue&type=script&lang=js"
export * from "./CardDatesDetailBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports